import { SHOP_ADMIN_PAGES_URLS } from '../../shop-administration.constants';

export const PAGE_URL_AFTER_SHOP_SWITCH: Record<string, string> = {
  [SHOP_ADMIN_PAGES_URLS['shop-details']]: SHOP_ADMIN_PAGES_URLS['shop-details'],
  [SHOP_ADMIN_PAGES_URLS['edit-shop']]: SHOP_ADMIN_PAGES_URLS['edit-shop'],
  [SHOP_ADMIN_PAGES_URLS['promotion-codes']]: SHOP_ADMIN_PAGES_URLS['promotion-codes'],
  [SHOP_ADMIN_PAGES_URLS['categories-settings']]: SHOP_ADMIN_PAGES_URLS['categories-settings'],
  [SHOP_ADMIN_PAGES_URLS['new-product']]: SHOP_ADMIN_PAGES_URLS['new-product'],
  [SHOP_ADMIN_PAGES_URLS['edit-product']]: SHOP_ADMIN_PAGES_URLS['shop-details'],
  [SHOP_ADMIN_PAGES_URLS['order-administration']]: SHOP_ADMIN_PAGES_URLS['order-administration'],
  [SHOP_ADMIN_PAGES_URLS['order-accept']]: SHOP_ADMIN_PAGES_URLS['order-administration'],
  [SHOP_ADMIN_PAGES_URLS['order-reject']]: SHOP_ADMIN_PAGES_URLS['order-administration'],
  [SHOP_ADMIN_PAGES_URLS['create-order']]: SHOP_ADMIN_PAGES_URLS['create-order'],
  [SHOP_ADMIN_PAGES_URLS['order-statistics']]: SHOP_ADMIN_PAGES_URLS['order-statistics'],
  [SHOP_ADMIN_PAGES_URLS['best-sellers']]: SHOP_ADMIN_PAGES_URLS['best-sellers'],
  [SHOP_ADMIN_PAGES_URLS['order-billing']]: SHOP_ADMIN_PAGES_URLS['order-billing'],
  [SHOP_ADMIN_PAGES_URLS.users]: SHOP_ADMIN_PAGES_URLS.users,
  [SHOP_ADMIN_PAGES_URLS['client-details']]: SHOP_ADMIN_PAGES_URLS.users,
  [SHOP_ADMIN_PAGES_URLS['api-keys']]: SHOP_ADMIN_PAGES_URLS['api-keys'],
  [SHOP_ADMIN_PAGES_URLS.integrations]: SHOP_ADMIN_PAGES_URLS.integrations,
  [SHOP_ADMIN_PAGES_URLS.invoices]: SHOP_ADMIN_PAGES_URLS.invoices,
  [SHOP_ADMIN_PAGES_URLS['cash-journal']]: SHOP_ADMIN_PAGES_URLS['cash-journal'],
  [SHOP_ADMIN_PAGES_URLS.reservations]: SHOP_ADMIN_PAGES_URLS.reservations,
  [SHOP_ADMIN_PAGES_URLS['reservation-decision']]: SHOP_ADMIN_PAGES_URLS.reservations,
};
